import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { Container, Nav, Navbar, Row, Col, Button } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import Marquee from "react-fast-marquee";
import { IoLocationOutline, IoCallOutline } from "react-icons/io5";
import {
  MdOutlinePhoneAndroid,
  MdOutlineDashboard,
  MdHealthAndSafety,
} from "react-icons/md";
import { IoHome } from "react-icons/io5";
import { ImPriceTag } from "react-icons/im";
import { RiContactsFill } from "react-icons/ri";
import { FaWhatsapp } from "react-icons/fa";
const AppBar = () => {
  return (
    <>
      <>
        <div className="mark-bg">
          <div className="d-lg-block d-none">
            <Container fluid>
              <Row className="py-2">
                <Col
                  lg="4"
                  xs="4"
                  sm="4"
                  className="align-self-center d-lg-block d-none"
                >
                  <div className="d-flex align-items-center">
                    <div>
                      <img
                        src={require("../../assets/images/gpay.png")}
                        className="img-fluid gpay"
                        alt="gpay"
                      />
                    </div>
                    <div className="text-white">
                      <h5 className="bold mt-2 mx-2">91235 27915 / 82481 14500</h5>
                    </div>
                  </div>
                </Col>
                <Col lg="8" className="align-self-center text-white">
                  <Marquee
                    pauseOnHover={true}
                    direction="left"
                    speed={50}
                    delay={9}
                  >
                    | Whatsapp : +91 91235 27915 | Mobile No : +91 82481 14500 | Sivakasi Market Price - Shri Thiruppathi Hariharan Crackers
                  </Marquee>
                </Col>
              </Row>
            </Container>
          </div>
          <div className="d-lg-none d-block py-3">
            <Container fluid>
              <Row>
                <Col xs="4" sm="4">
                  <a href="https://wa.me/919123527915?text=Hello%20Sivakasi%20Market%20Price">
                    <div className="mob-icon mx-auto">
                      <img
                        src={require("../../assets/images/whatsappicon.webp")}
                        className="img-fluid"
                        alt="whatsapp"
                      />
                    </div>
                  </a>
                </Col>
                <Col xs="4" sm="4">
                  <a href="tel:+919123527915">
                    <div className="mob-icon mx-auto">
                      <img
                        src={require("../../assets/images/callicon.webp")}
                        className="img-fluid"
                        alt="call"
                      />
                    </div>
                  </a>
                </Col>
                <Col xs="4" sm="4">
                  <a href="https://maps.app.goo.gl/jWAZ4TpUUehJfpnB6" target="_blank" rel="noreferrer">
                    <div className="mob-icon mx-auto">
                      <img
                        src={require("../../assets/images/googlelocation.png")}
                        className="img-fluid"
                        alt="location"
                      />
                    </div>
                  </a>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </>
      <>
        {/* <div  className='navv-bg bg-overlay'>
        <Container className='py-3 z'>
            <Row>
              <Col lg='4' md='12' xs="12">
                <Navbar.Brand href="/">
                  <div className='logo mx-auto'>
                    <img src={require('../../assets/images/storelogo.png')} className='img-fluid' alt='product name' />
                  </div>
              </Navbar.Brand>
              </Col>
              <Col lg='4' className='align-self-center d-lg-block d-none'>
                <div className='d-flex justify-content-center '>
                    <div></div>
                    <div>
                      <h5 className='bold'> Address</h5>
                      <p className='regular'> 3/1362/30 Bharathi Nagar, Sivakamipuram Colony, <br/>
                      Sivakasi - 626189
                      </p>
                    </div>
                </div>
              </Col>
              <Col lg='4' className='align-self-center d-lg-block d-none'>
                <div className='d-flex justify-content-center '>
                    <div></div>
                    <div class>
                      <h5 className='bold'> Mobile Number</h5>
                        <div className='regular'>
                          <li>+91 9003885080</li>
                          <li>+91 9944726077</li>
                        </div>
                    </div>
                </div>
              </Col>
            </Row>
        </Container>
      </div> */}
      </>

      <>
        <Navbar expand="lg" className=" headnav">
          <Container fluid className="px-lg-5">
            <Navbar.Brand href="/">
              <div className="logo mx-auto">
                <img
                  src={require("../../assets/images/logosm.png")}
                  className="img-fluid"
                  alt="product name"
                />
              </div>
            </Navbar.Brand>
            <div className="mx-auto">
              <Navbar.Toggle aria-controls="basic-navbar-nav mx-auto text-center py-3" />
            </div>

            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="ms-auto text-center py-3">
                <Nav.Link as={NavLink} exact to={"/"}>
                  Home
                </Nav.Link>
                <Nav.Link as={NavLink} exact to={"/about"}>
                  About
                </Nav.Link>
                <Nav.Link as={NavLink} exact to={"/products"}>
                  Pricelist
                </Nav.Link>
                <Nav.Link as={NavLink} exact to={"/safetytips"}>
                  Safety Tips
                </Nav.Link>
                <Nav.Link as={NavLink} exact to={"/contactus"}>
                  Contact
                </Nav.Link>
                {/* <Nav.Link as={NavLink} exact to={"/safetytips"} activeClassName="active">Safety Tips</Nav.Link>
              <Nav.Link as={NavLink} exact to={"/contactus"} activeClassName="active">Contact Us</Nav.Link> */}
              </Nav>
              {/* <Nav.Link as={NavLink} exact to={"/products"} activeClassName="active" className='text-center estimate'>Estimate Now !!!</Nav.Link> */}
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </>
    </>
  );
};
const AppBarTwo = () => {
  return (
    <>
      <>
        <div className="mark-bg">
          <div className="d-lg-block d-none">
            <Container fluid>
              <Row className="py-2">
                <Col
                  lg="4"
                  xs="4"
                  sm="4"
                  className="align-self-center d-lg-block d-none"
                >
                  <div className="d-flex align-items-center">
                    <div>
                      <img
                        src={require("../../assets/images/gpay.png")}
                        className="img-fluid gpay"
                        alt="gpay"
                      />
                    </div>
                    <div className="text-white">
                      <h5 className="bold mt-2 mx-2">91235 27915 / 82481 14500</h5>
                    </div>
                  </div>
                </Col>
                <Col lg="8" className="align-self-center text-white">
                  <Marquee
                    pauseOnHover={true}
                    direction="left"
                    speed={50}
                    delay={9}
                  >
                    Whatsapp : +91 91235 27915 | Mobile No : +91 82481 14500 | Sivakasi Market Price - Shri Thiruppathi Hariharan Crackers
                  </Marquee>
                </Col>
              </Row>
            </Container>
          </div>
          <div className="d-lg-none d-block py-3">
            <Container fluid>
              <Row>
                <Col xs="4" sm="4">
                  <a href="https://wa.me/919123527915?text=Hello%20Sivakasi%20Market%20Price">
                    <div className="mob-icon mx-auto">
                      <img
                        src={require("../../assets/images/whatsappicon.webp")}
                        className="img-fluid"
                        alt="whatsapp"
                      />
                    </div>
                  </a>
                </Col>
                <Col xs="4" sm="4">
                  <a href="tel:+919123527915">
                    <div className="mob-icon mx-auto">
                      <img
                        src={require("../../assets/images/callicon.webp")}
                        className="img-fluid"
                        alt="call"
                      />
                    </div>
                  </a>
                </Col>
                <Col xs="4" sm="4">
                  <a href="https://maps.app.goo.gl/jWAZ4TpUUehJfpnB6" target="_blank" rel="noreferrer">
                    <div className="mob-icon mx-auto">
                      <img
                        src={require("../../assets/images/googlelocation.png")}
                        className="img-fluid"
                        alt="product name"
                      />
                    </div>
                  </a>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </>
      <>
        <div className="navlink-bg">
          <Container className="py-3 z">
            <Row>
              <Col lg="4" md="12" xs="12">
                <Navbar.Brand href="/">
                  <div className="logo mx-auto">
                    <img
                      src={require("../../assets/sivasakthicrackersimage/download.png")}
                      className="img-fluid"
                      alt="product name"
                    />
                  </div>
                </Navbar.Brand>
              </Col>
              <Col lg="4" className="align-self-center d-lg-block d-none">
                <div className="d-flex justify-content-center ">
                  <div className="me-3">
                    <IoLocationOutline size={45} color="white" />
                  </div>
                  <div>
                    <h5 className="bold text-white"> Address</h5>
                    <p className="regular text-white">
                      {" "}
                      Mettamalai, Sattur to Sivakasi Main Road
                    </p>
                  </div>
                </div>
              </Col>
              <Col lg="4" className="align-self-center d-lg-block d-none">
                <div className="d-flex justify-content-center ">
                  <div className="me-3">
                    <MdOutlinePhoneAndroid size={45} color="white" />
                  </div>
                  <div class>
                    <h5 className="bold text-white"> Mobile Number</h5>
                    <div className="regular text-white">
                      <li>+91 96264 44988</li>
                      <li>+91 97877 08980</li>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </>

      <>
        <Navbar expand="lg" className="nav-pad nav-bg">
          <Container className="px-lg-5">
            <div className="mx-auto">
              <Navbar.Toggle aria-controls="basic-navbar-nav mx-auto text-center py-3" />
            </div>
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="me-auto text-center">
                <Nav.Link as={NavLink} exact to={"/"}>
                  Home
                </Nav.Link>
                <Nav.Link as={NavLink} exact to={"/about"}>
                  About
                </Nav.Link>
                <Nav.Link as={NavLink} exact to={"/products"}>
                  Pricelist
                </Nav.Link>
                <Nav.Link as={NavLink} exact to={"/safetytips"}>
                  Safety Tips
                </Nav.Link>
                <Nav.Link as={NavLink} exact to={"/contactus"}>
                  Contact
                </Nav.Link>
                {/* <Nav.Link as={NavLink} exact to={"/safetytips"} activeClassName="active">Safety Tips</Nav.Link>
              <Nav.Link as={NavLink} exact to={"/contactus"} activeClassName="active">Contact Us</Nav.Link> */}
              </Nav>
              {/* <Nav.Link as={NavLink} exact to={"/products"} activeClassName="active" className='text-center estimate'>Estimate Now !!!</Nav.Link> */}
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </>
    </>
  );
};
const AppBarThree = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedApp, setSelectedApp] = useState(null);

  const handleShow = (app) => {
    setSelectedApp(app);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedApp(null);
  };

  const qrCodes = {
    gpay: require("../../assets/images/payment_qr.jpg"),
    phonepe: require("../../assets/images/payment_qr.jpg"),
  };
  return (
    <>
      <>
        <div className="mark-bg">
          <div className="d-lg-block d-none">
            <Container fluid>
              <Row className="py-0">
                <Col
                  lg="4"
                  xs="4"
                  sm="4"
                  className="align-self-center d-lg-block d-none"
                >
                  <div className="d-flex align-items-center">
                    <div>
                      <img
                        src={require("../../assets/images/Gpay.jpg")}
                        alt="GPay"
                        style={{
                          width: "50px",
                          cursor: "pointer",
                          borderRadius: "50px",
                          marginRight: "10px",
                        }}
                        onClick={() => handleShow("gpay")}
                      />

                      <img
                        src={require("../../assets/images/Phonepay.png")}
                        alt="PhonePe"
                        style={{
                          width: "50px",
                          cursor: "pointer",
                          borderRadius: "50px",
                        }}
                        onClick={() => handleShow("phonepe")}
                      />
                    </div>
                    <>
                      <Modal show={showModal} onHide={handleClose} centered>
                        <Modal.Header closeButton>
                          <Modal.Title style={{ fontSize: "1.1rem", fontWeight: "bold" }}>
                            {selectedApp === "gpay" && "Google Pay (GPay) Payment"}
                            {selectedApp === "phonepe" && "PhonePe Payment"}
                          </Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="text-center p-3">
                          <h6 className="fw-bold mb-1" style={{ color: "#7B0F1C" }}>
                            SRI THIRUPPATHI HARIHARAN CRACKERS
                          </h6>
                          <div className="p-2 mb-2 rounded" style={{ background: "#FEF3C7", border: "1px solid #F59E0B" }}>
                            <div className="fw-bold">
                              {selectedApp === "gpay" ? (
                                <>Google Pay Number: <span style={{ color: "#1a73e8" }}>8531964818</span></>
                              ) : (
                                <>PhonePe Number: <span style={{ color: "#5f259f" }}>9123527915</span></>
                              )}
                            </div>
                            <div className="small text-muted mt-1">
                              UPI ID: <strong>thiruppathihariharancrackers@tmb</strong>
                            </div>
                          </div>
                          {selectedApp && qrCodes[selectedApp] && (
                            <img
                              src={qrCodes[selectedApp]}
                              alt={`${selectedApp} QR`}
                              style={{ maxHeight: "360px", maxWidth: "100%", borderRadius: "8px" }}
                            />
                          )}
                        </Modal.Body>
                        <Modal.Footer className="d-flex justify-content-center">
                          <Button variant="secondary" onClick={handleClose}>
                            Close
                          </Button>
                        </Modal.Footer>
                      </Modal>
                    </>
                    <div className=" d-lg-block d-none ">
                      <h5 className="bold mt-2 mx-2">91235 27915 / 82481 14500</h5>
                    </div>
                  </div>
                </Col>
                <Col lg="8" className="align-self-center ">
                  <Marquee
                    pauseOnHover={true}
                    direction="left"
                    speed={50}
                    delay={9}
                  >
                    💥 "சிவகாசி மார்க்கெட் பிரைஸ் - SIVAKASI MARKET PRICE (ஸ்ரீ திருப்பதி ஹரிஹரன் கிராக்கர்ஸ் - Shri Thiruppathi Hariharan Crackers)! அனைத்து வகை பட்டாசுகளும் சிறந்த தரம் & நேரடி ஆலை விலையில்!" 🎆
                    நேரடி ஆர்டருக்கு: (91235 27915 / 82481 14500)
                  </Marquee>
                </Col>
              </Row>
            </Container>
          </div>
        </div>

        <>
          <div
            className="d-lg-none d-block py-3 align-self-center"
            style={{
              backgroundColor: "#feba17",
            }}
          >
            <Container
              fluid
              className="d-flex "
              style={{
                width: "100%",
                justifyContent: "space-evenly",
                alignItems: "center",
              }}
            >
              {/* <a href="https://wa.me/918940655143?text=Hello Sri Senthur Murugan fireworks">
                <div className="mob-icon mx-auto">
                  <img
                    src={require("../../assets/images/whatsappicon.webp")}
                    className="img-fluid"
                    alt="product name"
                  />
                </div>
              </a> */}

              <div className="d-flex align-items-center">
                <div>
                  <Row style={{ width: "100vw" }}>
                    <Col
                      xs={4}
                      sm={4}
                      className="d-flex justify-content-start align-items-center"
                    >
                      <div style={{ marginRight: "10px" }}>
                        <img
                          src={require("../../assets/images/Gpay.jpg")}
                          alt="GPay"
                          className="img-fluid"
                          style={{
                            width: "60px",
                            cursor: "pointer",
                            borderRadius: "50px",
                          }}
                          onClick={() => handleShow("gpay")}
                        />
                      </div>
                    </Col>
                    <Col
                      xs={4}
                      sm={4}
                      className="d-flex justify-content-center align-items-center"
                    >
                      <div
                        style={{
                          fontSize: "17px",
                          fontWeight: "bold",
                          color: "black",
                        }}
                      >
                        91235 27915 / 82481 14500
                      </div>
                    </Col>
                    <Col
                      xs={4}
                      sm={4}
                      className="d-flex justify-content-end align-items-center"
                    >
                      <div style={{ marginLeft: "10px" }}>
                        <img
                          src={require("../../assets/images/Phonepay.png")}
                          alt="PhonePe"
                          className="img-fluid"
                          style={{
                            width: "60px",
                            cursor: "pointer",
                            borderRadius: "50px",
                          }}
                          onClick={() => handleShow("phonepe")}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
                <>
                  <Modal show={showModal} onHide={handleClose} centered>
                    <Modal.Header closeButton>
                      <Modal.Title style={{ fontSize: "1.1rem", fontWeight: "bold" }}>
                        {selectedApp === "gpay" && "Google Pay (GPay) Payment"}
                        {selectedApp === "phonepe" && "PhonePe Payment"}
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="text-center p-3">
                      <h6 className="fw-bold mb-1" style={{ color: "#7B0F1C" }}>
                        SRI THIRUPPATHI HARIHARAN CRACKERS
                      </h6>
                      <div className="p-2 mb-2 rounded" style={{ background: "#FEF3C7", border: "1px solid #F59E0B" }}>
                        <div className="fw-bold">
                          {selectedApp === "gpay" ? (
                            <>Google Pay Number: <span style={{ color: "#1a73e8" }}>8531964818</span></>
                          ) : (
                            <>PhonePe Number: <span style={{ color: "#5f259f" }}>9123527915</span></>
                          )}
                        </div>
                        <div className="small text-muted mt-1">
                          UPI ID: <strong>thiruppathihariharancrackers@tmb</strong>
                        </div>
                      </div>
                      {selectedApp && qrCodes[selectedApp] && (
                        <img
                          src={qrCodes[selectedApp]}
                          alt={`${selectedApp} QR`}
                          style={{ maxHeight: "360px", maxWidth: "100%", borderRadius: "8px" }}
                        />
                      )}
                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant="secondary" onClick={handleClose}>
                        Close
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </>
              </div>

              {/*<Col xs="4" sm="4">
                  <a href="tel:+918940655143">
                    <div className="mob-icon mx-auto">
                      <img
                        src={require("../../assets/images/callicon.webp")}
                        className="img-fluid"
                        alt="product name"
                      />
                    </div>
                  </a>
                </Col>*/}
              {/*<Col xs="4" sm="4">
                  <a href="https://maps.app.goo.gl/A66cTebzzfAq56QdA" alt="">
                    <div className="mob-icon mx-auto">
                      <img
                        src={require("../../assets/images/googlelocation.png")}
                        className="img-fluid"
                        alt="product name"
                      />
                    </div>
                  </a>
                </Col>*/}
            </Container>
          </div>
        </>
        <>
          <div className="bg-img bg-overlay">
            <Container fluid className="py-3 z">
              <Row>
                <Col lg="2" className="text-center">
                  <div className="mx-3 ">
                    <img
                      style={{
                        width: "150px",
                      }}
                      src={require("../../assets/images/Logo_updated-01.png")}
                      alt="company-logo"
                    />
                  </div>
                </Col>
                <Col lg="4">
                  <Navbar.Brand href="/">
                    <div className="logo company-name-head  mt-3">
                      <h2 className="logo-head-ft">
                        SIVAKASI MARKET PRICE
                        <br />
                      </h2>
                      <hr className="logo-head-ul" />
                      <h6 className="logo-head-sd">
                        Best Quality Crackers @ Whole Sale Price
                      </h6>
                    </div>
                  </Navbar.Brand>
                </Col>
                <Col lg="6" className="d-lg-block d-none py-5">
                  <Navbar expand="lg" className="nav-bg">
                    <Container>
                      <div>
                        <Navbar.Toggle aria-controls="basic-navbar-nav  text-center " />
                      </div>
                      <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className=" text-center">
                          <Nav.Link as={NavLink} exact to={"/home"}>
                            Home
                          </Nav.Link>
                          <Nav.Link as={NavLink} exact to={"/about"}>
                            About
                          </Nav.Link>
                          <Nav.Link as={NavLink} exact to={"/"}>
                            Pricelist
                          </Nav.Link>
                          <Nav.Link as={NavLink} exact to={"/safetytips"}>
                            Safety Tips
                          </Nav.Link>
                          <Nav.Link as={NavLink} exact to={"/contactus"}>
                            Contact
                          </Nav.Link>
                          {/* <Nav.Link as={NavLink} exact to={"/safetytips"} activeClassName="active">Safety Tips</Nav.Link>
              <Nav.Link as={NavLink} exact to={"/contactus"} activeClassName="active">Contact Us</Nav.Link> */}
                        </Nav>
                        {/* <Nav.Link as={NavLink} exact to={"/products"} activeClassName="active" className='text-center estimate'>Estimate Now !!!</Nav.Link> */}
                      </Navbar.Collapse>
                    </Container>
                  </Navbar>
                </Col>
              </Row>
            </Container>
          </div>
        </>

        <>
          <Navbar className="nav-pad nav-bg d-lg-none d-block fixed-bottom">
            <Container className="px-lg-5">
              <div className="mx-auto">
                <Navbar.Toggle aria-controls="basic-navbar-nav mx-auto text-center py-3" />
              </div>
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="me-auto text-center">
                  <Nav.Link
                    as={NavLink}
                    exact
                    to={"/home"}
                    className="margin-20"
                  >
                    <IoHome />
                    Home
                  </Nav.Link>
                  {/* <Nav.Link as={NavLink} exact to={"/about"} className='margin-20'><MdOutlineDashboard />About</Nav.Link> */}
                  <Nav.Link as={NavLink} exact to={"/"} className="margin-20">
                    <ImPriceTag />
                    Pricelist
                  </Nav.Link>
                  {/* <Nav.Link as={NavLink} exact to={"/safetytips"} className='margin-20'><MdHealthAndSafety />Safety Tips</Nav.Link> */}
                  <Nav.Link
                    as={NavLink}
                    exact
                    to={"/contactus"}
                    className="margin-20"
                  >
                    <RiContactsFill />
                    Contact
                  </Nav.Link>
                  {/* <Nav.Link as={NavLink} exact to={"/safetytips"} activeClassName="active">Safety Tips</Nav.Link>
              <Nav.Link as={NavLink} exact to={"/contactus"} activeClassName="active">Contact Us</Nav.Link> */}
                </Nav>
                {/* <Nav.Link as={NavLink} exact to={"/products"} activeClassName="active" className='text-center estimate'>Estimate Now !!!</Nav.Link> */}
              </Navbar.Collapse>
            </Container>
          </Navbar>
        </>
      </>
    </>
  );
};
const AppBarFour = () => {
  const mapLink =
    "https://maps.app.goo.gl/jWAZ4TpUUehJfpnB6";

  const headingLines = [
    "🏭 Factory Price",
    "🎆 Crackers Price",
    "📦 Wholesale Price",
    "🛒 Retail Price",
    "🤝 Customer Service",
    "🚀 Direct Sales",
    "💥 Sivakasi Market Price",
    "📍 Sivakasi Direct Sale",
    "🚫 No Offer / No Discount",
    "🛍️ Product Sales",
    "💰 Low Price / Lowest Price",
    "⭐ Best Quality / Best Price",
    "🛡️ Public Safety Money",
    "⏳ Advance Booking Save 100% Margin",
  ];

  return (
    <>
      {/* 1. Top Ribbon Marquee Strip */}
      <div
        className="top-ribbon-bar py-1 d-none d-lg-block"
        style={{
          background: "linear-gradient(90deg, #3D0710 0%, #5A0B16 50%, #3D0710 100%)",
          borderBottom: "2px solid #F4B942",
          color: "#FFF8E7",
          fontSize: "0.85rem",
        }}
      >
        <Container fluid className="px-lg-4">
          <Row className="align-items-center g-0">
            <Col lg={4} className="d-flex align-items-center gap-2">
              <span
                className="badge px-2.5 py-1 text-dark fw-bold"
                style={{
                  background: "linear-gradient(135deg, #F4B942 0%, #F59E0B 100%)",
                  borderRadius: "20px",
                  fontSize: "0.75rem",
                }}
              >
                ✨ SIVAKASI DIRECT OUTLET
              </span>
              <span style={{ color: "#FDE68A", fontSize: "0.82rem", fontWeight: "600" }}>
                Wholesale & Retail Direct Sales
              </span>
            </Col>

            <Col lg={5} className="text-center overflow-hidden">
              <Marquee pauseOnHover={true} direction="left" speed={45}>
                💥 சிவகாசி மார்க்கெட் பிரைஸ் - SIVAKASI MARKET PRICE | ஸ்ரீ திருப்பதி ஹரிஹரன் கிராக்கர்ஸ் - Shri Thiruppathi Hariharan Crackers! 🏭 Factory Price | Wholesale & Retail Price | Direct Sales | No Offer / No Discount | Lowest Price | Best Quality | Advance Booking Save 100% Margin 🎆 நேரடி ஆர்டருக்கு: 91235 27915 / 82481 14500
              </Marquee>
            </Col>

            <Col lg={3} className="text-end d-flex justify-content-end align-items-center gap-3">
              <a
                href="https://wa.me/919123527915?text=Hello%20Sivakasi%20Market%20Price"
                target="_blank"
                rel="noreferrer"
                className="text-decoration-none fw-bold"
                style={{ color: "#25D366", fontSize: "0.82rem" }}
              >
                <FaWhatsapp size={15} className="me-1" />
                91235 27915
              </a>
              <span style={{ color: "#F59E0B" }}>|</span>
              <a
                href="tel:+918248114500"
                className="text-decoration-none fw-bold text-white"
                style={{ fontSize: "0.82rem" }}
              >
                <IoCallOutline size={15} className="me-1" />
                82481 14500
              </a>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Mobile Top Marquee */}
      <div
        className="top-ribbon-bar py-1 d-block d-lg-none"
        style={{
          background: "linear-gradient(90deg, #3D0710 0%, #5A0B16 100%)",
          borderBottom: "1px solid #F4B942",
          color: "#FFF8E7",
          fontSize: "0.8rem",
        }}
      >
        <Marquee pauseOnHover={true} direction="left" speed={45}>
          💥 சிவகாசி மார்க்கெட் பிரைஸ்! SIVAKASI MARKET PRICE (Shri Thiruppathi Hariharan Crackers)! Factory Price | Wholesale Price | Direct Sales | No Offer / No Discount! ஆர்டருக்கு: 91235 27915 / 82481 14500
        </Marquee>
      </div>

      {/* 2. Main Desktop Header Bay - Fresh Luxury Pattern */}
      <div
        className="brand-main-header d-none d-lg-block py-3 position-relative"
        style={{
          background: "linear-gradient(180deg, #FFFFFF 0%, #FFF9F0 100%)",
          borderBottom: "2px solid #7B0F1C",
          boxShadow: "0 4px 15px rgba(123, 15, 28, 0.06)",
        }}
      >
        <Container className="px-lg-4">
          <Row className="align-items-center">
            {/* Left: Brand Identity with 3D Circular Logo */}
            <Col lg={7} className="d-flex align-items-center gap-3">
              <a href="/" className="text-decoration-none flex-shrink-0">
                <div
                  className="rounded-circle p-1 bg-white"
                  style={{
                    width: "110px",
                    height: "110px",
                    border: "3px solid #7B0F1C",
                    boxShadow: "0 6px 20px rgba(123, 15, 28, 0.22)",
                    transition: "transform 0.3s ease",
                  }}
                >
                  <img
                    src={require("../../assets/images/logosm.png")}
                    alt="Sivakasi Market Price Logo"
                    className="w-100 h-100 rounded-circle object-fit-contain"
                  />
                </div>
              </a>
              <div>
                <h1
                  className="bold mb-1"
                  style={{
                    color: "#3D0710",
                    fontSize: "1.85rem",
                    letterSpacing: "0.5px",
                    fontFamily: "serif",
                    lineHeight: "1.1",
                  }}
                >
                  SIVAKASI MARKET PRICE
                </h1>
                <div
                  className="fw-bold mb-1"
                  style={{
                    color: "#A16207",
                    fontSize: "0.96rem",
                    letterSpacing: "0.3px",
                  }}
                >
                  Shri Thiruppathi Hariharan Crackers | Wholesale & Retail | Direct Factory Rates
                </div>
                <div className="d-flex align-items-center gap-1 text-secondary" style={{ fontSize: "0.85rem" }}>
                  <IoLocationOutline size={16} color="#7B0F1C" />
                  <span>8-392-A, Indian Oil Petrol Pump Backside, Naranapuram, Sivakasi - 626189</span>
                </div>
              </div>
            </Col>

            {/* Right: Quick Action Cards */}
            <Col lg={5}>
              <div className="d-flex justify-content-end gap-3">
                {/* Store Location Card */}
                <a
                  href={mapLink}
                  target="_blank"
                  rel="noreferrer"
                  className="text-decoration-none"
                  style={{ minWidth: "185px" }}
                >
                  <div
                    className="p-2.5 px-3 rounded-3 d-flex align-items-center gap-2 h-100"
                    style={{
                      background: "#FFFFFF",
                      border: "1.5px solid #7B0F1C",
                      boxShadow: "0 3px 10px rgba(123, 15, 28, 0.12)",
                      transition: "all 0.3s ease",
                    }}
                  >
                    <div
                      className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                      style={{
                        width: "38px",
                        height: "38px",
                        background: "linear-gradient(135deg, #7B0F1C 0%, #3D0710 100%)",
                        color: "#F4B942",
                      }}
                    >
                      <IoLocationOutline size={20} />
                    </div>
                    <div>
                      <div className="fw-bold" style={{ color: "#7B0F1C", fontSize: "0.76rem" }}>
                        STORE OUTLET
                      </div>
                      <div className="fw-bold text-dark" style={{ fontSize: "0.82rem" }}>
                        Naranapuram, Sivakasi
                      </div>
                    </div>
                  </div>
                </a>

                {/* Direct Call Card */}
                <div
                  className="p-2.5 px-3 rounded-3 d-flex align-items-center gap-2"
                  style={{
                    background: "#FFFFFF",
                    border: "1.5px solid #7B0F1C",
                    boxShadow: "0 3px 10px rgba(123, 15, 28, 0.12)",
                    minWidth: "185px",
                  }}
                >
                  <div
                    className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                    style={{
                      width: "38px",
                      height: "38px",
                      background: "linear-gradient(135deg, #7B0F1C 0%, #3D0710 100%)",
                      color: "#F4B942",
                    }}
                  >
                    <IoCallOutline size={20} />
                  </div>
                  <div>
                    <div className="fw-bold" style={{ color: "#7B0F1C", fontSize: "0.76rem" }}>
                      ORDER HELPLINE
                    </div>
                    <div className="fw-bold" style={{ fontSize: "0.82rem", lineHeight: "1.3" }}>
                      <a href="tel:+919123527915" style={{ color: "#1F2937", textDecoration: "none" }}>
                        91235 27915
                      </a>
                      <br />
                      <a href="tel:+918248114500" style={{ color: "#1F2937", textDecoration: "none" }}>
                        82481 14500
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Mobile Header Bay - Distinct Mobile Pattern */}
      <div
        className="d-lg-none d-block px-3 py-3"
        style={{
          background: "linear-gradient(180deg, #FFFFFF 0%, #FFF9F0 100%)",
          borderBottom: "2px solid #7B0F1C",
        }}
      >
        <Container>
          <div className="d-flex align-items-center gap-2 mb-3">
            <a href="/" className="flex-shrink-0">
              <img
                src={require("../../assets/images/logosm.png")}
                alt="Sivakasi Market Price Logo"
                style={{
                  width: "75px",
                  height: "75px",
                  borderRadius: "50%",
                  border: "2.5px solid #7B0F1C",
                  boxShadow: "0 4px 12px rgba(123, 15, 28, 0.18)",
                }}
              />
            </a>
            <div className="flex-grow-1">
              <h2
                className="bold mb-0"
                style={{ color: "#3D0710", fontSize: "1.15rem", fontFamily: "serif" }}
              >
                SIVAKASI MARKET PRICE
              </h2>
              <div className="fw-bold" style={{ color: "#A16207", fontSize: "0.76rem" }}>
                Shri Thiruppathi Hariharan Crackers | Wholesale & Retail
              </div>
              <div className="text-secondary" style={{ fontSize: "0.74rem" }}>
                📍 Naranapuram, Sivakasi - 626189
              </div>
            </div>
          </div>

          {/* Quick Action Touch Pills (Call, WhatsApp, Map) */}
          <Row className="g-2 mb-1">
            <Col xs={4}>
              <a
                href="tel:+919123527915"
                className="btn w-100 py-1.5 px-1 d-flex flex-column align-items-center justify-content-center text-decoration-none"
                style={{
                  background: "#7B0F1C",
                  color: "#F4B942",
                  borderRadius: "10px",
                  border: "1px solid #F4B942",
                  fontSize: "0.75rem",
                  fontWeight: "bold",
                }}
              >
                <IoCallOutline size={16} className="mb-0.5" />
                Call
              </a>
            </Col>
            <Col xs={4}>
              <a
                href="https://wa.me/919123527915?text=Hello%20Sivakasi%20Market%20Price"
                target="_blank"
                rel="noreferrer"
                className="btn w-100 py-1.5 px-1 d-flex flex-column align-items-center justify-content-center text-decoration-none"
                style={{
                  background: "#25D366",
                  color: "#FFFFFF",
                  borderRadius: "10px",
                  fontSize: "0.75rem",
                  fontWeight: "bold",
                }}
              >
                <FaWhatsapp size={16} className="mb-0.5" />
                WhatsApp
              </a>
            </Col>
            <Col xs={4}>
              <a
                href={mapLink}
                target="_blank"
                rel="noreferrer"
                className="btn w-100 py-1.5 px-1 d-flex flex-column align-items-center justify-content-center text-decoration-none"
                style={{
                  background: "linear-gradient(135deg, #F4B942 0%, #F59E0B 100%)",
                  color: "#3D0710",
                  borderRadius: "10px",
                  fontSize: "0.75rem",
                  fontWeight: "bold",
                }}
              >
                <IoLocationOutline size={16} className="mb-0.5" />
                Map
              </a>
            </Col>
          </Row>
        </Container>
      </div>

      {/* 3. Golden Flame Curved Navbar */}
      <Navbar
        expand="lg"
        className="py-1"
        collapseOnSelect
        style={{
          background: "linear-gradient(90deg, #3D0710 0%, #7B0F1C 50%, #3D0710 100%)",
          borderBottom: "3px solid #F4B942",
          boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
        }}
      >
        <Container>
          {/* Mobile Menu Toggle Button */}
          <div className="w-100 d-flex justify-content-center d-lg-none my-1">
            <Navbar.Toggle
              aria-controls="mobile-navbar-nav"
              className="border-0 w-100 py-2"
              style={{
                background: "linear-gradient(135deg, #F4B942 0%, #F59E0B 100%)",
                color: "#3D0710",
                fontWeight: "900",
                borderRadius: "25px",
                boxShadow: "0 4px 15px rgba(245, 158, 11, 0.4)",
                border: "2px solid #F4B942",
                maxWidth: "96%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
              }}
            >
              <span style={{ fontSize: "1.05rem", color: "#3D0710" }}>
                ☰ MENU & PRODUCTS
              </span>
            </Navbar.Toggle>
          </div>

          <Navbar.Collapse id="mobile-navbar-nav">
            <Nav className="me-auto text-center py-2 w-100 justify-content-center align-items-center gap-lg-2">
              <Nav.Link
                className="text-white px-3 py-2 fw-bold"
                as={NavLink}
                exact
                to={"/home"}
                style={{ fontSize: "0.98rem", borderRadius: "8px" }}
              >
                Home
              </Nav.Link>
              <Nav.Link
                className="text-white px-3 py-2 fw-bold"
                as={NavLink}
                exact
                to={"/about"}
                style={{ fontSize: "0.98rem", borderRadius: "8px" }}
              >
                About Us
              </Nav.Link>
              <Nav.Link
                className="px-4 py-2 my-1 my-lg-0 fw-bold"
                as={NavLink}
                exact
                to={"/"}
                style={{
                  background: "linear-gradient(135deg, #F4B942 0%, #F59E0B 100%)",
                  color: "#3D0710",
                  borderRadius: "25px",
                  boxShadow: "0 0 15px rgba(255, 215, 0, 0.6)",
                  border: "2px solid #FFF",
                  fontSize: "1rem",
                  letterSpacing: "0.5px",
                }}
              >
                💥 Price List 2026 💥
              </Nav.Link>
              <Nav.Link
                className="text-white px-3 py-2 fw-bold"
                as={NavLink}
                exact
                to={"/safetytips"}
                style={{ fontSize: "0.98rem", borderRadius: "8px" }}
              >
                Safety Tips
              </Nav.Link>
              <Nav.Link
                className="text-white px-3 py-2 fw-bold"
                as={NavLink}
                exact
                to={"/contactus"}
                style={{ fontSize: "0.98rem", borderRadius: "8px" }}
              >
                Contact Us
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* 4. Heading Line Add Strip */}
      <div
        className="heading-lines-ticker py-2"
        style={{
          background: "linear-gradient(90deg, #7B0F1C 0%, #991B1B 50%, #7B0F1C 100%)",
          borderBottom: "2px solid #F4B942",
          boxShadow: "0 3px 10px rgba(0, 0, 0, 0.25)",
        }}
      >
        <Container fluid className="px-0">
          <Marquee pauseOnHover={true} speed={50} gradient={false}>
            {headingLines.map((item, idx) => (
              <span
                key={idx}
                className="mx-2 px-3 py-1 fw-bold rounded-pill text-nowrap"
                style={{
                  background: "rgba(0, 0, 0, 0.35)",
                  border: "1.5px solid #F4B942",
                  color: "#F4B942",
                  fontSize: "0.86rem",
                  letterSpacing: "0.4px",
                  display: "inline-flex",
                  alignItems: "center",
                  boxShadow: "0 2px 6px rgba(0, 0, 0, 0.2)",
                }}
              >
                {item}
              </span>
            ))}
          </Marquee>
        </Container>
      </div>
    </>
  );
};


export { AppBar, AppBarTwo, AppBarThree, AppBarFour };
